import { render, staticRenderFns } from "./AnalisisSentimientosTwitter.vue?vue&type=template&id=6f681eeb&"
import script from "./AnalisisSentimientosTwitter.vue?vue&type=script&lang=js&"
export * from "./AnalisisSentimientosTwitter.vue?vue&type=script&lang=js&"
import style0 from "./AnalisisSentimientosTwitter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports